<template>
  <div class="dologin-wrapper">
    <div v-if="errorMessage" class="dologin-error-card">
      <div class="dologin-error-icon">&#9888;</div>
      <p class="dologin-error-text">{{ errorMessage }}</p>
    </div>
    <div v-else class="dologin-redirecting">{{ $t("redirecting.text") }}</div>
  </div>
</template>

<script>
import axios from "axios";
import { helpers } from "../helper/portal_config";

export default {
  name: "DoLogin",
  data() {
    return {
      accessCode: "",
      errorMessage: "",
      errorSubMessage: "",
      trackings: {
        dlpc: "",
        daff: "",
        dtrv: "",
        dsrc: "",
        dusr: "",
        dtim: "",
        devt: "",
      },
      currentLanguage: "",
      currentCountry: ""
    };
  },
  methods: {
    doLogin() {
      axios
        .get(
          `https://api.hubdelivery.io/store/checkAccessCode?portal_name=${
            helpers.portal_name
          }&country=${this.currentCountry}&language=${this.currentLanguage}&access_code=${
            this.accessCode
          }`
        )
        .then((response) => {
          if (response.data.treatment == 1) {
            this.$store
              .dispatch("globals/login", {
                accessCode: this.accessCode,
              })
              .then(() => {
                this.$router.push("/");
              });
          } else {
            if (response.data.error_code === 2089) {
              this.errorMessage = "Your access to the portal has expired.";
              this.errorSubMessage = "To regain access and continue using the portal, please subscribe again.";
            } else {
              this.errorMessage = "Invalid login link.";
              this.errorSubMessage = "Please check your link or request a new one.";
            }
          }
        })
        .catch((error) => {
          const errorCode = error.response?.data?.error_code;
          if (errorCode === 2089) {
            this.errorMessage = this.$t('error.E2089');
          } else {
            this.errorMessage = this.$t('error.E2002');
          }
        });
    },
    generateUUID() {
      return this.$uuid.v1();
    },
    setCurrentCountry() {
      const { host } = window.location;
      this.currentCountry = host.split('.')[0].slice(0,2).toUpperCase();
    },
    setCurrentLanguage() {
      var lang = "";
      const { host } = window.location;
      var country = host.split('.')[0].slice(0,2).toUpperCase();
      if (helpers.country_default_language.hasOwnProperty(country)) {
        lang = helpers.country_default_language[country].toUpperCase();
      } else {
        lang = country.toUpperCase();
      }
      this.currentLanguage = lang;
    },
    trSetParamsItems($q) {
      // set default value
      this.trackings.daff = helpers.affiliate_landing;
      this.trackings.dsrc = helpers.source_landing;
      this.trackings.dtrv = this.generateUUID();
      this.trackings.dlpc = helpers.landing_page_id;
      if (!this.$cookies.get("d_user_id")) {
        this.$cookies.set("d_user_id", this.generateUUID());
      }
      if (Object.keys($q).length == 0) return;

      const paramsLength = Object.entries($q).length;
      for (const [key, value] of Object.entries($q)) {
        console.log(key);
        console.log(value);
        if (key === "trv") {
          this.trackings.dtrv = value;
        }
        if (key === "src") {
          this.trackings.dsrc = value;
        }
        if (key === "aff") {
          this.trackings.daff = value;
        }
        if (key === "lpc") {
          this.trackings.dlpc = value;
        }
        if (key === "usr") {
          if (!this.$cookies.get("d_user_id")) {
            this.$cookies.set("d_user_id", value);
          }
        }
      }
    },
  },
  created() {
    this.trSetParamsItems(this.$route.query);
    this.setCurrentLanguage();
    this.setCurrentCountry();
  },
  mounted() {
    window.addEventListener("load", (event) => {
      if (
        this.$route.params.accesscode &&
        this.$route.params.accesscode.length > 0
      ) {
        this.accessCode = this.$route.params.accesscode;
        setTimeout(() => {
          this.doLogin();
        }, 1500);
      } else {
        this.$router.go(-1);
      }
    });
  },
};
</script>


<style scoped>
.dologin-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #1a1a1a;
  padding: 20px;
}

.dologin-redirecting {
  color: #fff;
  font-size: 16px;
}

.dologin-error-card {
  background: #fff;
  border-radius: 12px;
  padding: 40px 30px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.dologin-error-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.dologin-error-text {
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  margin: 0;
}
</style>
